import { render } from "./Procedures.vue?vue&type=template&id=6c1d79a1&scoped=true"
import script from "./Procedures.vue?vue&type=script&lang=js"
export * from "./Procedures.vue?vue&type=script&lang=js"

import "./Procedures.vue?vue&type=style&index=0&id=6c1d79a1&scoped=true&lang=css"

import exportComponent from "/oudini/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c1d79a1"]])

export default __exports__